import axios from 'axios';
import { LanguageObject } from '@/i18n';
import { Survey, SurveyParticipation, Question } from './SurveyUtils';

interface SubOrganization {
  id?: number;
  survey: Partial<Survey>;
  surveyparticipation: Partial<SurveyParticipation>;
  question: Partial<Question>;
  name: LanguageObject;
  order: number;
}

const api = {
  list: async (params?: {
    questionid?: number;
    surveyparticipationid?: number;
  }) => {
    const resp = await axios.get<SubOrganization[]>(
      '/subOrganization/list.php',
      { params: params }
    );
    return resp.data;
  },

  get: async (id: number) => {
    const resp = await axios.get<SubOrganization>('/subOrganization/get.php', {
      params: { id: id },
    });
    return resp.data;
  },

  add: async (suborgs: SubOrganization[]) => {
    const resp = await axios.post<number[]>('/subOrganization/add.php', {
      suborganizations: suborgs,
    });
    suborgs = suborgs.map((suborg, index) => ({
      ...suborg,
      id: resp.data[index],
    }));
    return suborgs;
  },

  update: async (suborg: Partial<SubOrganization>) => {
    await axios.post('/subOrganization/update.php', suborg);
  },

  remove: async (id: number) => {
    await axios.delete('/subOrganization/delete.php', {
      params: { id: id },
    });
  },

  save: async (
    suborganizations: (SubOrganization & {
      order?: number;
      action?: 'add' | 'update' | 'delete';
    })[]
  ) => {
    const resp = await axios.post<number[]>('/subOrganization/save.php', {
      suborganizations: suborganizations,
    });

    return suborganizations
      .filter((suborg) => suborg.action !== 'delete')
      ?.map((suborg) => ({
        ...suborg,
        id: suborg.id ? suborg.id : resp.data.shift(),
      }));
  },
};

export default {
  api,
};

export { SubOrganization };
